import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as auth0 from 'auth0-js';
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  userProfile: any;
  requestedScopes = 'openid profile';

  auth0: auth0.WebAuth;

  constructor(public router: Router,
              private cookieService: CookieService) {

    this.auth0 = this.createAuth0Instance();
  }

  public login(redirectParams?: string): void {
    if (redirectParams) {
      this.auth0 = this.createAuth0Instance(redirectParams);
    }
    this.auth0.authorize();
  }

  public handleAuthentication(): Promise<any> {
    const thisObj = this;
    return new Promise(((resolve) => {
      thisObj.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          window.location.hash = '';
          thisObj.setSession(authResult);
        } else if (err) {
          console.log(err);
          alert('Error: ${err.error}. Check the console for further details.');
        }
        resolve();
      });
    }));
  }

  private setSession(authResult): void {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());

    // If there is a value on the scope param from the authResult,
    // use it to set scopes in the session for the user. Otherwise
    // use the scopes as requested. If no scopes were requested,
    // set it to nothing
    const scopes = authResult.scope || this.requestedScopes || '';

    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    localStorage.setItem('scopes', JSON.stringify(scopes));
    if (authResult.idTokenPayload) {
      localStorage.setItem('email', authResult.idTokenPayload.name);
      localStorage.setItem('auth0Id', authResult.idTokenPayload.sub);
    }
  }

  public logout(redirectParams?: string): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('scopes');
    localStorage.removeItem('email');
    localStorage.removeItem('auth0Id');

    this.auth0.logout({
      returnTo: window.location.origin + (redirectParams ? redirectParams : "")
    });
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // Access Token's expiry time
    const expiresAtVal = localStorage.getItem('expires_at');
    if (expiresAtVal) {
      const expiresAt = JSON.parse(expiresAtVal);
      return new Date().getTime() < expiresAt;
    } else {
      return false;
    }
  }

  public userHasScopes(scopes: Array<string>): boolean {
    const grantedScopes = JSON.parse(localStorage.getItem('scopes')).split(' ');
    return scopes.every(scope => grantedScopes.includes(scope));
  }

  public getAuth0Id(): string {
    return localStorage.getItem('auth0Id');
  }

  public getEmail(): string {
    return localStorage.getItem('email');
  }

  private createAuth0Instance(redirectParams?: string): auth0.WebAuth {
    return new auth0.WebAuth({
      clientID: 'kYdFGHN2k9D0GufeTxocLBLrNUhaLZnx',
      domain: 'wasy-software.eu.auth0.com',
      responseType: 'token id_token',
      audience: 'https://business-owner-details/',
      redirectUri: window.location.origin + (redirectParams ? redirectParams : ""),
      scope: 'openid profile'
    });
  }
}
